/** Список страниц, на которых существует альтернативная кнопка открытия видео инструкций */
export const urlBlackList = [
	'/personal-account',
	'/personal-account/warehouses',
	'/personal-account/fish-products',
	'/personal-account/applications',
	'/personal-account/payments',
	'/personal-account/settings',
	'/storage-account',
	'/storage-account/applications',
	'/storage-account/suppliers',
	'/storage-account/fish-products',
	'/storage-account/additional-services',
	'/storage-account/refrigerators',
	'/storage-account/settings',
];
